import defaultSettings from '@/settings';

const title = defaultSettings.title || 'Vue Element Admin';

export default function getPageTitle(pageTitle) {
  // if (pageTitle) {
  //   return `${pageTitle} - ${title}`
  // }
  if (window.vm) {
    return `${window.vm.$t('route.' + pageTitle)} - ${title}`;
  }
  return `${title}`;
}
